export default "__VITE_ASSET__B_ZQ8D5j__"